import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/httpVentures'

export const investorTypeList = (params = '') => Http.get(`/admin/venture-investor-types${serialize(params)}`)
export const investorTypeCreate = (params = '') => Http.post('/admin/venture-investor-types', params)
export const investorTypeByID = (params = '') => Http.get(`/admin/venture-investor-types/${params}`)
export const investorTypeUpdate = (params = '') => Http.put(`/admin/venture-investor-types/${params.id}`, params)
export const investorTypeDestroy = (params = '') => Http.delete(`/admin/venture-investor-types/${params.id}`)
